import TextField, { TextFieldProps } from "@mui/material/TextField";

export default function FormText(props: TextFieldProps) {
  return <TextField autoComplete="off" {...props} />;
}
